<template>
  <div class="d-flex flex-column monkey-buttons">
    <v-btn
      v-if="showCardPayment"
      x-large
      depressed
      color="primary"
      :disabled="disableCardPayment || locked"
      class="mt-8"
      @click="payBy(PaymentMethod.CARD)"
    >
      <v-icon x-large left v-text="icons.creditCard" />
      {{ __('offsetCard') }}
    </v-btn>
    <v-btn
      v-if="showCashPayment"
      x-large
      depressed
      color="primary"
      :disabled="disableCashPayment || locked"
      class="mt-8"
      @click="showCalculator = true"
    >
      <v-icon x-large left v-text="icons.cash" />
      {{ __('inCash') }}
    </v-btn>
    <v-dialog
      v-model="showCalculator"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card light tile>
        <v-card-title>
          {{ __('toPay') }}
          <v-spacer />
          {{ amountToPay | currency }}
        </v-card-title>
        <v-card-title>
          {{ __('change') }}
          <v-spacer />
          {{ change | currency }}
        </v-card-title>
        <v-card-title class="grey lighten-4 display-1">
          <v-spacer />
          {{ floatValue | currency }}
          <v-spacer />
        </v-card-title>
        <h-calculator
          :value="value"
          @input="$emit('input', $event)"
          light
        />
        <v-card-actions>
          <v-btn
            text
            color="grey darken-1"
            @click="cancelCashPayment()"
          >
            {{ __('cancel') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="! canPayInCash || locked || paymentInProgress"
            depressed
            color="primary"
            :loading="printing"
            @click="payBy(PaymentMethod.CASH)"
          >
            {{ __('pay') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Click blocker overlay during payment -->
    <h-click-blocker
      v-model="paymentInProgress"
      :z-index="203"
      transparent
    />
  </div>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import ProcessesPayments from '@/Mixins/ProcessesPayments'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HCalculator from '@/Components/Calculator'
  import HClickBlocker from '@/Components/ClickBlocker'

  export default {
    mixins: [
      Currenciable,
      I18n,
      ProcessesPayments,
      UsesIcons,
    ],

    components: {
      HCalculator,
      HClickBlocker,
    },

    props: {
      printing: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      win: 'methods',
      showCalculator: false,
      paymentInProgress: false,
    }),

    computed: {
      change () {
        return Math.max(this.floatValue - this.amountToPay, 0)
      },
      floatValue () {
        return this.intAmount / 100
      },
      canPayInCash () {
        return this.intAmount === 0 || this.floatValue.greaterThanOrEqualTo(this.amountToPay)
      },
      showPaymentDialog () {
        return this.$store.getters['orders/dialogs/payment']
      },
    },

    watch: {
      showPaymentDialog (isOpen) {
        // Reset payment in progress when payment dialog opens
        if (isOpen) {
          this.paymentInProgress = false
        }
      },
    },

    mounted () {
      // Listen for payment events from ProcessesPayments mixin
      this.$on('payment-failed', this.onPaymentFailed)
      this.$on('paid', this.onPaymentSuccess)
    },

    beforeDestroy () {
      // Clean up event listeners
      this.$off('payment-failed', this.onPaymentFailed)
      this.$off('paid', this.onPaymentSuccess)
    },

    methods: {
      cancelCashPayment () {
        this.showCalculator = false
        this.$emit('input', '0')
        this.paymentInProgress = false
      },
      payBy (method) {
        // Activate blocker for both card and cash payments
        this.paymentInProgress = true
        this.$log('Payment initiated, activating blocker', 'MonkeyMode', method)
        // Call parent payBy from ProcessesPayments mixin
        ProcessesPayments.methods.payBy.call(this, method)
      },
      onPaymentFailed () {
        // Remove blocker immediately when payment fails
        this.paymentInProgress = false
        this.$log('Payment failed, blocker removed', 'MonkeyMode')
      },
      onPaymentSuccess () {
        // Payment was successful, but keep blocker until dialog closes
        // It will be removed by the showPaymentDialog watcher when dialog opens again
        this.$log('Payment succeeded', 'MonkeyMode')
      },
    },
  }
</script>

<style scoped>
  .monkey-buttons {
    padding: 3em 2em;
  }
</style>
